import { PAPI, COUNTRIES } from '@marketmuse/config/types';

export const getCountryEnum = (country: string): PAPI.Country => {
  const countryKey = country.toUpperCase() as COUNTRIES.CodesPapi;
  return PAPI.Country[countryKey] || PAPI.Country.US;
};
